import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header.tsx';
import Hero from './Hero.tsx';
import Pricing from './Pricing.tsx';
import Footer from './Footer.tsx';
import WinTheGame from './WinTheGame.tsx';
import VideoTypesTutorials from './VideoTypesTutorials.tsx';
import KnowledgePower from './KnowledgePower.tsx';
import Testimonials from './Testimonials.tsx';
import SiteTour from './SiteTour.tsx';
import WhyCards from './WhyCards.tsx';

const Home = () => {
  const location = useLocation();
  const lastHash = useRef('');

  useEffect(() => {
    if (location.hash) {
      lastHash.current = location.hash.slice(1); // safe hash for further use after navigation
    }

    if (lastHash.current && document.getElementById(lastHash.current)) {
      setTimeout(() => {
        document
          .getElementById(lastHash.current)
          ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        lastHash.current = '';
      }, 100);
    }
  }, [location]);

  return (
    <main className="h-screen landing-main">
      <Header />
      <Hero />
      <WinTheGame />
      <KnowledgePower />
      <VideoTypesTutorials />
      <Testimonials />
      <Pricing />
      <WhyCards />
      <SiteTour />
      <Footer />
    </main>
  );
};

export default Home;
